import { Button } from "../../../components/Buttons";
import Card from "../../../components/Card";
import dashImg from "../../../assets/Images/Dashboard/dashImg1.png"
import Headings from "../../../components/Texts/Headings";

export default function GetStartedComponent() {
  return (
    <Card className="flex-1">
      <Headings
        variant="secondary"
        className="text-[#00C08B]"
      >
        Complete Your Profile<br />to Apply for Loan
      </Headings>
      {/* <p className="font-[500] md:font-[700] text-[12px] md:text-[32px]  leading-[17px] text-[#00C08B] md:leading-[40px] tracking-[-2%]">
        Complete Your Profile <br />
        to Apply for Loan
      </p> */}
      <div className="grid grid-cols-5 gap-[40px]">
        <div className="col-span-3 flexCol justify-end">
          <Headings
            variant="tertiary"
            text="Get your preapproved loan now of ₹2 lakh"
          />
          <p className="font-[500] font-Apparat text-[12px] md:text-[15px] text-greyText  text-opacity-70 my-[8px]">
            Get great offers as a first time applicant and get instant
            cash in your bank A/C. upto 5,00,000.
          </p>
          <Button
            title="Apply Now"
            variant="secondary"
            className="mt-[22px] text-primary font-[700]"
          />
        </div>
        <div className="col-span-2">
          <img
            src={dashImg}
            className="object-contain w-[124.5px] md:w-[350px]  aspect-square"
          />
        </div>
      </div>
    </Card>
  )
}